<template>
  <div class="min-h-screen flex flex-col">
    <SiteHeader @toggleMenu="isOpen = !isOpen" :is-open="isOpen" />
    <main class="flex-grow bg-gradient-to-b from-black to-gray-900 relative z-0">
      <slot />
    </main>
    <Footer />
  </div>
  <MobileDropdownMenu v-if="isOpen" @close="isOpen = false" />
</template>

<script setup>
import SiteHeader from '@/components/layout/SiteHeader.vue';
import Footer from '@/components/layout/footer.vue';
import MobileDropdownMenu from '../header/MobileDropdownMenu.vue';
import { ref } from 'vue';

const isOpen = ref(false);

</script>